<template lang="html">
    <app-layout>
        <div class="home-container">
            <div class="home-left-images">
                <div
                    class="home-image home-top-left-image"
                    :style="setAssetBackground('home-top-left')"
                >
                </div>
                <div
                    class="home-image home-bottom-left-image"
                    :style="setAssetBackground('home-bottom-left')"
                >
                </div>
            </div>
            <div class="home-right-images">
                <div
                    class="home-image home-top-right-image"
                    :style="setAssetBackground('home-top-right')"
                >
                </div>
                <div
                    class="home-image home-bottom-right-image"
                    :style="setAssetBackground('home-bottom-right')"
                >
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/components/partials/app-layout.vue';
export default {
    components: {
        AppLayout
    },
    data () {
        return {
        };
    },
    computed: {

    },
    methods: {
        setAssetBackground(key){
            if(this.$store.state.imageAssets[key]){
                return `background-image: url("${this.$store.state.imageAssets[key]}");`;
            }
        }
    }


};
</script>

<style lang="scss">
    .home-container{
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: center;
        .home-image{
            background-size: cover;
            background-position: center;
            height: 300px;
            width: 100%;
            max-width: 450px;
            min-width: 400px;
        }
        .home-left-images{
            margin-right: 3rem;
        }
        .home-top-left-image{
            overflow: hidden;
            background-image: url("/static/img/home-top-left.jpg");
            margin-bottom: 3rem;
        }
        .home-top-right-image{
            margin-bottom: 3rem;
            overflow: hidden;
            background-image: url("/static/img/home-top-right.jpg");
        }
        .home-bottom-left-image{
            margin-top: 3rem;
            overflow: hidden;
            background-image: url("/static/img/home-bottom-left.jpg");
        }
        .home-bottom-right-image{
            margin-top: 3rem;
            overflow: hidden;
            margin-right: 4rem;
            background-image: url("/static/img/home-bottom-right.jpg");
        }
        img{
            object-fit: cover;
            object-position: center;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/page/Home/index.vue